import { useTheme } from '@emotion/react';
import { IconButton } from '@material-ui/core';
import { history, useIntl } from 'umi';
import { useSelector } from 'dva';
import DataTableNativeML from '@/components/DataTableNativeML';
import webStorage from '@/utils/storageManager';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ResultListStyled from './ResultListStyled';
import ButtonTip from '@/components/buttonTip/ButtonTip';
import { fmtThousand } from '@/utils/comUtil';

const COUPON_DATA = {
  DISCOUNT_COUPON: {
    url: '/coupon/coupon_list/discount',
    type: '1',
    auth: 'MENU_COUPON_DISCOUNT',
  },
  CASH_COUPON: {
    url: '/coupon/coupon_list/cash',
    type: '2',
    auth: 'MENU_COUPON_CASH',
  },
  FULL_DISCOUNT_COUPON: {
    url: '/coupon/coupon_list/full-discount',
    type: '3',
    auth: 'MENU_COUPON_FULL_DISCOUNT',
  },
  EXCHANGE_COUPON: {
    url: '/coupon/coupon_list/exchange',
    type: '4',
    auth: 'MENU_COUPON_EXCHANGE',
  },
  EXTERNAL_COUPON: {
    url: '/coupon/coupon_list/third_gift',
    type: '8',
    auth: 'MENU_COUPON_THIRD_GIFT_COUPON',
  },
  FREE_TICKET_COUPON: {
    url: '/coupon/coupon_list/free_pass',
    type: '9',
    auth: 'MENU_COUPON_FREE_PASS',
  },
  GIFT_COUPON: {
    url: '/coupon/coupon_list/gift',
    type: '10',
    auth: 'BTN_COUPON_GIFT_VOUCHER',
  },
  THIRD_PARTY_COUPON: {
    url: '/coupon/coupon_list/third',
    type: '11',
    auth: 'MENU_COUPON_EXTERNAL_COUPON',
  },
};

const ResultList = (props) => {
  const theme = useTheme();
  //过于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const pageData = props.pageData;
  const { handlePageChange } = props;
  // 用户菜单权限
  const userAuths = webStorage.get('USER')?.authorities || [];
  const { data: cpList, total } =
    useSelector((state) => state.cpList?.cpList) || {};
  const loadingEffect = useSelector((state) => state.loading);
  const couponListLoading = loadingEffect.effects['cpList/getCpList'];
  const { COUPON_TYPE = [] } = webStorage.get('DICTOBJ') || {};
  const typeList = COUPON_TYPE.map((item) => ({
    value: item.dictCode,
    name: item.nameZh,
  }));
  //状态
  const statusList = [
    { name: '未开始', value: 'NOT_START' },
    { name: '进行中', value: 'UNDER_WAY' },
    { name: '已结束', value: 'COMPLETE' },
  ];
  const columns = [
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl01' }),
      align: 'center',
      id: 'id',
      key: 'id',
    },
    {
      align: 'center',
      title: formatMessage({ id: 'coupon.mgt.c01.lbl02' }),
      id: 'title',
      event: {
        // onClick: (value, row) => handleMemberDetail(row),
      },
      // tdCellStyle: { color: 'rgb(21,101,192)', cursor: 'pointer' },
      width: '200',
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl03' }),
      align: 'center',
      id: 'comment',
      key: 'comment',
      // width: 120,
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl04' }),
      align: 'center',
      id: 'typeName',
      key: 'typeName',
      render: (rows) => {
        const name = typeList.find((i) => i.value === rows.typeName)?.name;
        return <div>{name}</div>;
      },
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl06' }),
      align: 'center',
      id: 'subTitle',
      key: 'subTitle',
      // width: 220,
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl07' }),
      align: 'center',
      id: 'statusName',
      key: 'statusName',
      render: (rows) => {
        const name = statusList.find((i) => i.value === rows.statusName).name;
        return <div>{name}</div>;
      },
      // width: 120,
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl08' }),
      align: 'center',
      id: 'received',
      key: 'received',
      render: (item) => {
        return (
          <span textAlign="center">
            {item.received !== null ? fmtThousand(item.received, 0) : ''}
          </span>
        );
      },
      // width: 120,
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl09' }),
      align: 'center',
      id: 'surplus',
      key: 'surplus',
      render: (item) => {
        return (
          <span textAlign="center">
            {item.surplus !== null ? fmtThousand(item.surplus, 0) : ''}
          </span>
        );
      },
      // width: 120,
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl10' }),
      align: 'center',
      id: 'beginTime',
      key: 'beginTime',
      width: '220',
      render: ({ beginTime, endTime }) => {
        return (
          <div className="date-wrapper">
            <span>{beginTime}</span>
            <span>{endTime}</span>
          </div>
        );
      },
    },
    {
      title: formatMessage({ id: 'coupon.mgt.c01.lbl11' }),
      align: 'center',
      id: 'mobile',
      key: 'mobile',
      width: 140,
      render: (item) => {
        const canEdit = item.statusName !== 'COMPLETE';
        const isExternalCoupon = !item.typeName;
        return (
          <div align="center" className="handle_btn">
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.03' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_coupon_center_coupon_management_list_edit',
                  events: ['_ev', '_ec'],
                  params: {
                    coupon_id: item.id,
                  },
                })}
                className={!canEdit && 'no-drop'}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (
                    canEdit &&
                    !isExternalCoupon &&
                    userAuths.includes(COUPON_DATA[item.typeName]?.auth)
                  ) {
                    history.push({
                      pathname: COUPON_DATA[item.typeName].url,
                      query: {
                        id: String(item.id),
                        type: COUPON_DATA[item.typeName]?.type,
                        source: 'btn_coupon_center_coupon_management_list_edit',
                      },
                    });
                  }
                }}
              >
                <SvgIconML
                  name="edit"
                  size={24}
                  fill={
                    canEdit &&
                    !isExternalCoupon &&
                    userAuths.includes(COUPON_DATA[item.typeName]?.auth)
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
                {/* <img src={editImg} alt="" /> */}
              </IconButton>
            </ButtonTip>
            <ButtonTip title={formatMessage({ id: 'comm.action.btn.05' })}>
              <IconButton
                data-log={JSON.stringify({
                  oid: 'btn_coupon_center_coupon_management_list_details',
                  events: ['_ev', '_ec'],
                  params: {
                    coupon_id: item.id,
                  },
                })}
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                onClick={() => {
                  if (!isExternalCoupon) {
                    history.push({
                      pathname: COUPON_DATA[item.typeName]?.url,
                      query: {
                        id: String(item.id),
                        opt: 'detail',
                        type: COUPON_DATA[item.typeName]?.type,
                        sourceOid:
                          'btn_coupon_center_coupon_management_list_details',
                      },
                    });
                  }
                }}
              >
                <SvgIconML
                  name="detail"
                  size={24}
                  fill={
                    !isExternalCoupon
                      ? theme.palette.primary.main
                      : theme.palette.secondary.disabled
                  }
                  className="preview"
                />
                {/* <img src={editImg} alt="" /> */}
              </IconButton>
            </ButtonTip>
          </div>
        );
      },
    },
  ];

  //换页
  const changePage = (obj) => {
    handlePageChange(obj);
  };

  return (
    <ResultListStyled>
      <DataTableNativeML
        loading={couponListLoading}
        columns={columns}
        changePage={changePage}
        page={pageData}
        data={cpList}
        total={total}
        paging={true}
        columnKey="id"
      ></DataTableNativeML>
    </ResultListStyled>
  );
};
export default ResultList;
